import { render, staticRenderFns } from "./SelfPlayer.vue?vue&type=template&id=1ac898cc"
import script from "./SelfPlayer.vue?vue&type=script&lang=js"
export * from "./SelfPlayer.vue?vue&type=script&lang=js"
import style0 from "./SelfPlayer.vue?vue&type=style&index=0&id=1ac898cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports